import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation User_evaluateCourse($id: ID!, $userCourseStatus: String!, $url: String!) {
    User_evaluateCourse(id: $id, userCourseStatus: $userCourseStatus, url: $url) {
      status
    }
  }
`;

const userEvaluateCourse = async ({ id, userCourseStatus, url }) =>
  graphql(mutation, { id, userCourseStatus, url }).then(data => data.User_evaluateCourse);

export default userEvaluateCourse;
